import { useRelevantQueryParams } from '@frontend/common';
import { ReportClient } from '@frontend/report/api';
import { Report, ReportType } from '@frontend/report/types';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

const REPORT_MODAL_ID = 'notifications-report-modal';

export const useNotifications = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { currentAccount } = useAccountRepository();
    const [report, setReport] = useState<Report | null>(null);
    const exportData: { [key: string]: any } = { ...useRelevantQueryParams() };

    useEffect(() => {
        ReportClient.fetchReports({
            type: ReportType.MESSAGEBIRD_NOTIFICATIONS,
            account_id: currentAccount
        }).then((response) => {
            setReport(response.results[0] ?? null);
        });
    }, [currentAccount]);

    return {
        dispatch,
        location,
        navigate,
        report,
        reportModalId: REPORT_MODAL_ID,
        exportData
    };
};
